import { defineStore } from "pinia";

export const useCommonStore = defineStore("common", {
    state: () => ({
        windowWidth: window.innerWidth,
        // solanaNetwork: "devnet",
        solanaNetwork: "mainnet-beta",
        devnetRpcEndpoint: "https://api.devnet.solana.com",
        'mainnet-betaRpcEndpoint': "https://bold-maximum-fog.solana-mainnet.quiknode.pro/fb924ecc1964a15e0734bca9b247b52e83e2dbba/",
        // webApiUrl: "http://127.0.0.1:3000/v1",
        webApiUrl: "https://api.mimirlab.xyz/v1",
        backtestApiUrl: "https://backtest-api.mimirlab.xyz/v1", 
        // backtestApiUrl: "http://127.0.0.1:8000/v1",
        // discordRedirectUri: "https://discord.com/api/oauth2/authorize?client_id=1180786640080355348&response_type=code&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Fprofile&scope=identify+email",
        discordRedirectUri: "https://discord.com/api/oauth2/authorize?client_id=1180786640080355348&response_type=code&redirect_uri=https%3A%2F%2Ftrade.mimirlab.xyz%2Fprofile&scope=identify+email",
    }),
});

export const useWalletStore = defineStore("wallet", {
    state: () => ({
        connect_status: false,
    }),
});

export const useStrategyStore = defineStore("strategy", {
    state: () => ({
        buy_point_settings: [],
        sell_point_settings: [],
        latest_price: null,
        latest_multiple_price: {},
        backtest_detail: null,
        backtest_compare: [],
        basic_form: {
            type: 'SPOT',
            exchange: 'jupiter',
            tradingPair: {
                label: 'SOL / USDC',
                value: 'SOLUSD',
                address: 'So11111111111111111111111111111111111111112',
                image: 'sol',
                start: new Date('2022-01-01T00:00:00Z')
            },
            leverage: 1,
        },
        collection_form: {
            name: '',
            symbol: '',
            description: '',
            image: '',
            attributes: []
        },
        detail_form: {
            total_supply: 50,
            complete_supply: 0, 
            royalties: 0,
            discord_invite_code: '',
            twitter_handle: '',
            website_link: '',
        },
        groups_form: {
            og: {
                name: 'og',
                price: 0.1,
                limit: 10,
                period: 24
            },
            wl: {
                name: 'wl',
                price: 0.1,
                hash_list: '',
                limit: 10,
                period: 24,
            },
            public: {
                name: 'public',
                price: 0.1
            }
        },
        sl_point: null,
        tp_point: null,
        backtest_period: [
            new Date('2022-02-04T00:00:00Z'),
            new Date()
        ]
    }),
});

// collection form
// {
//     name: 'Test StrategySSS',
//     symbol: 'TSSSS',
//     description: 'This is the first test strategy on Mainnet.',
//     image: 'data:image/png;base64,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',
//     attributes: []
// }

// detail form
// {
//     total_supply: 50,
//     royalties: 8,
//     discord_invite_code: '',
//     twitter_handle: '',
//     website_link: '',
// }

export const useBackpackStore = defineStore("backpack", {
    state: () => ({
        trade_records: [],
        is_farming: false,
    }),
});